var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade modal-send-information",
      attrs: {
        "aria-hidden": "true",
        "aria-labelledby": _vm.prefix + "-modal-send-information-label",
        id: _vm.prefix + "-modal-send-information",
        role: "dialog",
        tabindex: "-1"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-send-information--header" }, [
            _c("div", {
              staticClass: "bar-texture",
              class: [_vm.success ? "success" : "fail"]
            }),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-send-information--body" }, [
            _c(
              "h2",
              {
                staticClass: "modal-title",
                attrs: { id: _vm.prefix + "-modal-send-information-label" }
              },
              [_vm._v(_vm._s(_vm.message.title))]
            ),
            _vm._v(" "),
            _c("h3", {
              staticClass: "modal-subtitle",
              domProps: { innerHTML: _vm._s(_vm.message.subtitle) }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "info-icon",
                class: [_vm.success ? "success" : "fail"]
              },
              [
                _c("i", {
                  staticClass: "fas",
                  class: [_vm.success ? "fa-check" : "fa-exclamation"]
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-send-information--footer" })
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib?{}!./scripts/vue/components/common/ModalSendInformation.vue?vue&type=template&id=b978a214&
// module id = 56
// module chunks = 1 2